module.exports = __webpack_public_path__ + "static/media/bits.fff2b88f.png";